import React, {useEffect, useState} from 'react';
// import { Spinner } from "react-activity";
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import axios from 'axios';
import { apiUrl } from '../config/Config';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'bootstrap';
// import { useDispatch, useSelector } from "react-redux/es/exports";
import { useDispatch, useSelector } from 'react-redux';
import chlogo from '../assets/images/ch_logo.png';


const Login = () => {
    const [username, setusername] = useState(null);
    const [password, setpassword] = useState();
    const [showloding, setshowloding] = useState(false);
    const [token, settoken] = useState(null);
    const [showpasswordview, setshowpasswordview] = useState(false);
    // console.log('userdata >>', userdata);
    let navigate = useNavigate();
    const dispatch = useDispatch(); 
    const userdata = useSelector((store) => store.userReducer.userdata);
    
    const loginpressed = async() => {
      // navigate('/customer/home');
      if(username && password) {
        setshowloding(true);
        var data = {
            'username' : username,
            'password': password
        }
        const headers = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        }
        let resp = await axios.post(apiUrl + 'adminlogin', data, headers).then((res) => {
            if(res.data.status == 'success') {
              dispatch({ type: "userdata", payload: res.data.data })
              navigate('/dashboard');
            } else {
              alert(res.data.message);
            }
        } ).catch((err) => {
            alert(err.message)
        })
        setshowloding(false);
    } else {
        alert('username and password is required');
    }
    }  

    useEffect(() => {
        if (userdata && Object.keys(userdata).length > 0) {
            //   fetchdata();
            navigate("/users");
          } else {
          }
    }, [])

   

    return (
      <div className="loginBoxMaindiv">
        <div className="loginBox webloginBox">
        <img src={chlogo} />
        <div className="mb-3 mt-4">
          <label for="email" className="form-label">
            Email:
          </label>
          <input
            type="text"
            value={username} onChange={(t) => {setusername(t.target.value)}}
            className="form-control logininput"
            placeholder="Enter Email"
          />
        </div>
        <div className="mb-4">
          <label for="pwd" className="form-label">
            Password:
          </label>
          <input
            type="password"
            value={password} onChange={(t) => {setpassword(t.target.value)}}
            className="form-control logininput"
            id="pwd"
            placeholder="Enter password"
            name="pswd"
          />
        </div>
        <div className='mb-2'>
            <button type="button" className="btn btn-primary webcustom-btn"  onClick={() => {loginpressed()}}>
                {showloding ?
                <Spinner color='#fff' size={15} className='spinnerCenter' /> : 'LOGIN'
            }
            </button>
        </div>
        
        
      </div>
      </div>
      
    );
}

export default Login;